export function Label(props) {
  return <label className="text-sm font-medium" {...props} />;
}
